'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BaseLineSearch } from '@/app/components/icons/BaseLineSearch';
import { Input } from '@/app/components/ui/input';
import { useLocale } from '@/i18n/routing';

export default function BlogSearchBox() {
  const locale = useLocale();
  const t = useTranslations('blog');
  const [searchValue, setSearchValue] = useState('');
  const [isComposing, setIsComposing] = useState(false);

  const handleSearch = () => {
    if (!searchValue.trim()) return;

    const query = encodeURIComponent(`site:vidu.com${locale === 'en' ? '' : `/${locale}`} ${searchValue.trim()}`);
    const googleSearchUrl = `https://www.google.com/search?q=${query}`;

    window.open(googleSearchUrl, '_blank');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isComposing && e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  return (
    <div className="mt-10 flex w-full justify-center sm:mt-8">
      <div className="flex h-14 w-full max-w-[696px] items-center gap-3 rounded-[40px] border border-system-black/10 bg-system-white/80 px-6 shadow-[0_4px_20px_0_rgba(99,99,99,0.10)] sm:h-[38px] sm:px-4">
        <BaseLineSearch className="size-6 text-system-black/40 sm:size-[18px]" />
        <Input
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onCompositionStart={handleCompositionStart}
          onCompositionEnd={handleCompositionEnd}
          placeholder={t('search.placeholder')}
          className="flex-1 bg-transparent p-0 text-base text-black placeholder:text-system-black/40 sm:text-sm"
        />
      </div>
    </div>
  );
}
